
<div class="dashboard-content-sec">
    <div class="card mb-0">
        <app-breadcrumb [crumbList] = "crumbList"></app-breadcrumb>
        <div class="user-heading-sec">
            <div class="mr-4 d-inline-block">
                <span id="user-expand" class="p-2" href="#">
                        {{this.total}} Templates</span>
            </div>

        </div>

        <div id="templateTable" class="table-responsive">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table table-striped" >
                <thead>
                    <tr>
                        <th *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                            <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                            <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                            <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i> {{header.text}}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let tmpl of templates">
                        <tr>
                        
                            <td>
                                <a  href="javascrpt:void(0);" [routerLink]="['/admins/template/',tmpl]">
                                    {{tmpl}}
                                </a>
                            </td>
                            
                        </tr>

                    </ng-container>
                </tbody>

                <ng-container *ngIf="templates?.length == 0">
                  <tr><td colspan="2">No Result Found</td></tr>
                </ng-container>



            </table>
            <div class="has-text-centered align-items-end">
                <ul *ngIf="pager.pages && pager.pages.length && pager.pages.length>1" class="pagination">
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
